/* eslint-disable no-console */
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { AggregateDetails, SleeveDetails } from '../models/sleeve-details.model'

const ACCOUNT_DETAILS_HOST = `helios-account-details`
const SLEEVE_DETAILS_URL = `${ACCOUNT_DETAILS_HOST}/{accountId}/sleeveData`
const AGGREGATES_URL = `${ACCOUNT_DETAILS_HOST}/{accountId}/aggregates`

@Injectable({
  providedIn: 'root',
})
export class SleeveDetailsService {
  constructor(private readonly httpClient: HttpClient) {}

  getSleeveDetails(accountId: string): Observable<SleeveDetails[]> {
    return this.httpClient.get<SleeveDetails[]>(
      SLEEVE_DETAILS_URL.replace('{accountId}', accountId),
    )
  }

  getAggregateDetails(accountId: string): Observable<AggregateDetails[]> {
    return this.httpClient.get<AggregateDetails[]>(
      AGGREGATES_URL.replace('{accountId}', accountId),
    )
  }
}
